
/* injects from baggage-loader */

'use strict';

export default class LoginController {

	constructor($log, $state, $location, $stateParams, User, Alerts) {
		'ngInject';

		this.$log = $log;
		this.$state = $state;
		this.$location = $location;
		this.UserService = User;
		this.Alerts = Alerts;

		// Hold user login credentials
		this.user = {
			email: '',
			password: ''
		};

		this.isLoggingIn = false;

		// Hold login error details
		this.error = {};
		this.alert = {};

		// Get the referral page from state params
		this.referral = $stateParams.ref;

	}

	$onInit() {
		// this.$log.log(this.$stateParams);

		if (this.referral) {
			// Add alert to what happened to global alerts
			this.alert = {
				type: 'info',
				msg: 'Please log in before attempting to perform this action.'
			};
		}
	}

	login() {

		// Reject another login if the user is already being logged in
		if (this.isLoggingIn) {
			return false;
		}

		this.isLoggingIn = true;

		// Reset error
		this.error = {};

		// Attempt to authenticate the user
		this.UserService.authenticate(this.user)
		.then(user => {
			if (typeof this.referral !== 'undefined') {
				this.$location.path(this.referral).search({});
			} else {
				this.$state.go('account.home');
			}
		})
		.catch(err => {
			this.error = err;
			this.isLoggingIn = false;
		});

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.controller.js